export default "__VITE_ASSET__BwEPuFen__"